import { AppRoutes } from '../../../Core/App/AppRoutes';
import { AppRouteType } from '../../Components/Templates/AppRouter/AppRouteType';
import { PrivateRoute } from '../../Components/Templates/AppRouter/PrivateRoute';
import { LoadablePlanningPage } from '../../Pages/Planning/LoadablePlanningPage';

const getPlanningRoute = (props: object): AppRouteType => ({
    id: AppRoutes.PLANNING,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.PLANNING,
        component: LoadablePlanningPage,
        ...props,
    },
});

export const getPlanningRoutes = (args: object) => [getPlanningRoute(args)];
